import type { GridRenderEditCellParams } from '@mui/x-data-grid';
import { MAX_TO } from '@vy/types';
import { VayuTextField } from '../../../../../../../../components/design/vayu-theme-components/VayuTextField';

type EditTiersTablePerUnitNumberFieldProps = Pick<GridRenderEditCellParams, 'id' | 'value' | 'api' | 'field'>;

export const EditTiersTableCell: React.FC<EditTiersTablePerUnitNumberFieldProps> = ({
  id,
  value,
  api,
  field,
}) => {
  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    await api.setEditCellValue({
      value: newValue === '' ? `${MAX_TO}` : newValue,
      field,
      id,
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };

  return (
    <VayuTextField
      type="number"
      value={value === MAX_TO ? '' : value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onWheel={(e) => e.preventDefault()}
      autoFocus
    />
  );
};
